// Mock data for Al-Ulaimi Web Hosting

export const features = [
  {
    id: 1,
    title: 'استضافة فائقة السرعة',
    description: 'خوادم SSD عالية الأداء تضمن سرعة تحميل استثنائية لموقعك',
    icon: 'Zap'
  },
  {
    id: 2,
    title: 'أمان متقدم',
    description: 'حماية SSL مجانية وجدران حماية متقدمة لحماية بياناتك',
    icon: 'Shield'
  },
  {
    id: 3,
    title: 'دعم فني 24/7',
    description: 'فريق دعم متواجد دائماً للرد على استفساراتك',
    icon: 'Headphones'
  },
  {
    id: 4,
    title: 'نسخ احتياطي يومي',
    description: 'نسخ احتياطية تلقائية يومية لضمان حماية بياناتك',
    icon: 'Database'
  },
  {
    id: 5,
    title: 'لوحة تحكم سهلة',
    description: 'لوحة تحكم cPanel سهلة الاستخدام لإدارة موقعك',
    icon: 'Settings'
  },
  {
    id: 6,
    title: 'ضمان وقت التشغيل 99.9%',
    description: 'موثوقية عالية تضمن توفر موقعك على مدار الساعة',
    icon: 'Activity'
  }
];

export const plans = [
  {
    id: 1,
    name: 'الباقة الأساسية',
    price: '99',
    period: 'شهرياً',
    features: [
      '10 جيجا مساحة تخزين',
      'نقل بيانات غير محدود',
      '5 حسابات بريد إلكتروني',
      'شهادة SSL مجانية',
      'دعم فني 24/7'
    ],
    recommended: false
  },
  {
    id: 2,
    name: 'الباقة الاحترافية',
    price: '199',
    period: 'شهرياً',
    features: [
      '50 جيجا مساحة تخزين',
      'نقل بيانات غير محدود',
      'حسابات بريد غير محدودة',
      'شهادة SSL مجانية',
      'نسخ احتياطي يومي',
      'دعم فني ذو أولوية'
    ],
    recommended: true
  },
  {
    id: 3,
    name: 'باقة الأعمال',
    price: '399',
    period: 'شهرياً',
    features: [
      'مساحة تخزين غير محدودة',
      'نقل بيانات غير محدود',
      'حسابات بريد غير محدودة',
      'شهادة SSL متقدمة',
      'نسخ احتياطي كل ساعة',
      'خادم مخصص',
      'دعم VIP'
    ],
    recommended: false
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'أحمد السعيد',
    role: 'صاحب متجر إلكتروني',
    content: 'خدمة ممتازة وسرعة فائقة! موقعي أصبح أسرع بكثير بعد الانتقال إلى العليمي',
    rating: 5
  },
  {
    id: 2,
    name: 'فاطمة محمد',
    role: 'مطورة ويب',
    content: 'الدعم الفني رائع ومتجاوب. حل مشكلتي في دقائق معدودة',
    rating: 5
  },
  {
    id: 3,
    name: 'خالد العتيبي',
    role: 'رائد أعمال',
    content: 'أفضل استضافة جربتها! الأسعار منافسة والخدمة ممتازة',
    rating: 5
  }
];

// Mock function to save subscription
export const saveSubscription = (email, phone) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('تم حفظ الاشتراك:', { email, phone, timestamp: new Date() });
      resolve({ success: true, message: 'تم الاشتراك بنجاح!' });
    }, 1000);
  });
};